import React from 'react'
import { useTranslation } from 'react-i18next'
import { SECTION } from 'utils/section'
import { Logo } from './partials/Logo'
import { Navigation } from './partials/Navigation'
import { LanguageSwitch } from './partials/LanguageSwitch'
import logo from 'assets/img/logo-green.svg'
import styles from './Header.module.scss'

export const Header = () => {
  const { t } = useTranslation()
  return (
    <header id={SECTION.HEADER} className={styles['section']}>
      <div className={styles['container']}>
        <div className={styles['navigate']}>
          <div className={styles['navigate-side']}>
            <Logo />
          </div>
          <div className={styles['navigate-center']}>
            <Navigation />
          </div>
          <div className={styles['navigate-side']}>
            <LanguageSwitch />
          </div>
        </div>
      </div>
    </header>
  )
}
